import { render, staticRenderFns } from "./DepartAddDialog.vue?vue&type=template&id=0ce2a7bc&scoped=true"
import script from "./DepartAddDialog.vue?vue&type=script&lang=js"
export * from "./DepartAddDialog.vue?vue&type=script&lang=js"
import style0 from "./DepartAddDialog.vue?vue&type=style&index=0&id=0ce2a7bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2a7bc",
  null
  
)

export default component.exports